export default __webpack_public_path__ + "static/media/Stress Testing.3b575928.svg";